var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Summary } from './SummaryCharts/Summary';
import { StudentsTable } from './StudentsTable';
var PositionedSummary = styled(Summary).withConfig({ displayName: "PositionedSummary", componentId: "sc-vmo9e2" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 26px; /* 43 - 17 = 26 */\n"], ["\n  margin-bottom: 26px; /* 43 - 17 = 26 */\n"])));
var WeeklyReport = function (_a) {
    var weeklyReportData = _a.weeklyReportData, onBackToCurrentWeekClick = _a.onBackToCurrentWeekClick;
    return (_jsxs("div", { children: [_jsx(PositionedSummary, { data: weeklyReportData }, void 0), _jsx(StudentsTable, { students: weeklyReportData.students, onBackToCurrentWeekClick: onBackToCurrentWeekClick }, void 0)] }, void 0));
};
export { WeeklyReport };
var templateObject_1;
